// extracted by mini-css-extract-plugin
module.exports = {"bugfix":"mobileNavigation-module--bugfix--2tX2a","blogTag":"mobileNavigation-module--blogTag--359rT"};